import React, { Component } from 'react';
import { Tabs, Tab, Container, InputGroup, FormControl, Button, Modal, Form } from 'react-bootstrap';
import axios from 'axios';
import API from '../config_api';
import moment from 'moment';
import Select from 'react-select';
import { Calendar } from 'primereact/calendar';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';  // You can use any available theme
import 'primereact/resources/primereact.min.css';
import ReactStars from 'react-rating-stars-component';
class Classroom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            localOfflineProgramsList: [],
            localAttendanceProgramsList: [],
            location: [],
            seperate: [],
            allProgram: [],
            oneProgram: [],
            date: moment(new Date()).format('L'),
            today: [],
            searchText: '',
            tabType: 1,
            showAttendanceModal: false,
            selectedUnit: null, // Selected unit value
            selectedDate: new Date(), // Default value for Date
            trainingProgram: null, // Selected training program
            unitList: [
                { label: 'KCH', value: 'KCH' },
                { label: 'ACH', value: 'ACH' },
                { label: 'BCH', value: 'BCH' },
            ], // Example options for Unit Names
            trainingProgramsList: [
                { label: 'Training Program 1', value: 'program1' },
                { label: 'Training Program 2', value: 'program2' },
                { label: 'Training Program 3', value: 'program3' },
            ], // Example options for training programs

            rating: 0, // State to hold the rating value
            feedback: '', // State to hold feedback text
            requiredCheck: false, // State to check if rating is require
            showSaved: false, // State to show success message
            showAlert: false, // State to handle alert modal visibility
            alertMessage: '', // Message to display in alert modal
        };
    }

    sortDate(arr) {
        return arr.sort((a, b) => {
            const startDateA = moment(a.date.split(' - ')[0], "DD/MM/YYYY");
            const startDateB = moment(b.date.split(' - ')[0], "DD/MM/YYYY");
            return startDateA.diff(startDateB);
        });
    }

    componentDidMount() {
        const formData = new FormData();
        formData.append('user_id', localStorage.getItem('token'));

        const formData1 = new FormData();
        formData1.append('user_id', localStorage.getItem('token'));
        formData1.append('location', localStorage.getItem('location'));

        // Using Promise.all to make concurrent API requests
        Promise.all([
            axios.post(API.Record, formData, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            }),
            axios.post(API.Records, formData1, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            }),
            axios.post(API.Location, formData, {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            })
        ])
            .then(([res1, res2, res3]) => {
                console.log(res2.data.data)
                // Transform the locations data from the API response
                const transformedLocations = res3.data.data.map(item => ({
                    label: item.text, // or item.title if you prefer
                    value: item.value
                }));

                // Retrieve the default location from localStorage
                const defaultLocation = localStorage.getItem('location');

                // Find the default option that matches the stored location value
                const defaultLocationOption = transformedLocations.find(option => option.value === defaultLocation);

                // Update the state with the transformed data and other API responses
                this.setState({
                    location: transformedLocations, // Set the options for the select box
                    selectedUnit: defaultLocationOption ? defaultLocationOption.value : null, // Set the default selected value if available
                    seperate: res1.data.data,
                    localOfflineProgramsList: res1.data.data,
                    allProgram: res2.data.data,
                    localAttendanceProgramsList: res2.data.data,
                });

                const filteredItems = this.filterItemsByDate1(moment(this.state.date).format('DD/MM/YYYY'))
                const test = filteredItems.filter(item => item.location === defaultLocation)
                const filteredSumStatusItems = test.filter(item => {
                   
                    return item.sum_status === "0";
                })
                const transformedLocations1 = filteredSumStatusItems.map(item => ({
                    label: `${item.program_name} (${item.fromTime + '-' + item.toTime})`, // Show program name with date
                    value: item.id
                }));

                this.setState({ today: transformedLocations1 })
            })
            .catch(error => {
                console.error("Error fetching data:", error);
            });
    }

    filterItemsByDate1(targetDate) {
        console.log('filter', targetDate, this.state.localOfflineProgramsList)
        return this.state.allProgram.filter(item => {
            // console.log('item 1', item.date)
            const dateRange = item.date.split(' - ');
            const startDate = moment(dateRange[0], 'DD/MM/YYYY');
            const endDate = moment(dateRange[1], 'DD/MM/YYYY');
            // console.log('item 2', moment(targetDate, 'DD/MM/YYYY').isBetween(startDate, endDate))
            // Check if targetDate is in between the date range
            return moment(targetDate, 'DD/MM/YYYY').isBetween(startDate, endDate) || moment(targetDate, 'DD/MM/YYYY').isSame(startDate)
                || moment(targetDate, 'DD/MM/YYYY').isSame(endDate)
            // return targetDate.isBetween(startDate, endDate, null, '[]');
        });
    }
    componentDidUpdate(prevProps, prevState) {
        // Check if the localAttendanceProgramsList has changed before setting the state
        if (prevState.localAttendanceProgramsList !== this.state.localAttendanceProgramsList) {
            const filteredItems = this.sortDate(
                this.filterItemsByDate(moment(this.state.date).format('DD/MM/YYYY'))
            );

            // Only update the state if the filtered items have actually changed
            if (JSON.stringify(filteredItems) !== JSON.stringify(this.state.localOfflineProgramsList)) {
                this.setState({ localOfflineProgramsList: filteredItems });
            }
        }
    }

    filterItemsByDate(targetDate) {
        return this.state.localAttendanceProgramsList.filter(item => {
            const [startDateString, endDateString] = item.date.split(' - ');
            const startDate = moment(startDateString, 'DD/MM/YYYY');
            const endDate = moment(endDateString, 'DD/MM/YYYY');

            return (
                moment(targetDate, 'DD/MM/YYYY').isBetween(startDate, endDate) ||
                moment(targetDate, 'DD/MM/YYYY').isSame(startDate) ||
                moment(targetDate, 'DD/MM/YYYY').isSame(endDate) ||
                moment(targetDate, 'DD/MM/YYYY').isBefore(startDate)
            );
        });
    }

    toggleShowMore = (index) => {
        const updatedPrograms = this.state.localOfflineProgramsList.map((program, i) =>
            i === index ? { ...program, showMore: !program.showMore } : program
        );
        this.setState({ localOfflineProgramsList: updatedPrograms });
    };

    // Search handling function
    onChangeText = (text) => {
        this.setState({ searchText: text });
        const filteredPrograms = this.state.localOfflineProgramsList.filter((program) =>
            program.program_name.toLowerCase().includes(text.toLowerCase()) ||
            program.trainer.toLowerCase().includes(text.toLowerCase()) ||
            program.date.toLowerCase().includes(text.toLowerCase())
        );
        this.setState({ localOfflineProgramsList: filteredPrograms });
    };

    // Clear search text
    clearText = () => {
        this.setState({ searchText: '' });
        this.componentDidMount(); // Reloads the data after clearing search
    };
    toggleShowMoreAttendance = (index) => {
        const updatedPrograms = this.state.seperate.map((program, i) =>
            i === index ? { ...program, showMore: !program.showMore } : program
        );
        this.setState({ seperate: updatedPrograms });
    };

    handleAttendanceModalShow = () => {
        this.setState({ showAttendanceModal: true });
    };

    handleAttendanceModalClose = () => {
        this.setState({ showAttendanceModal: false });
    };
    handleSubmit = () => {
        // Handle form submission logic here
        const { trainingProgram, rating, feedback } = this.state;

        if (rating === 0) {
            this.setState({ requiredCheck: true });
            return; // Prevent form submission if the rating is not provided
        }

        console.log("Unit Name:", feedback);
        console.log("Date:", rating);
        console.log("Selected Training Program:", trainingProgram);

        let formData = new FormData()
        formData.append('user_id', localStorage.getItem('token'));
        formData.append('training_id', trainingProgram);
        formData.append('rating', rating);
        formData.append('feedback', feedback);

        axios.post(API.Attandance, formData, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        })
            .then((response) => {
                // Determine the message based on the response
                let msg = response.data.message === 'already enrolled'
                    ? 'You have already marked your attendance for this training program.'
                    : 'Your attendance has been submitted. Once it is validated by the trainer you will see your digital record of completion under offline learning records.';

                if (response.data.message === 'already enrolled') {
                    this.setState({ alertMessage: msg, showAlert: true });
                } else {
                    this.setState({ showSaved: true });
                }
            })
            .catch((error) => {
                console.error("Error submitting attendance:", error);
            });
        // Close the modal
        this.handleAttendanceModalClose();
    };

    handleUnitChange = (selectedUnit) => {
        console.log(selectedUnit)

        const formData1 = new FormData();
        formData1.append('user_id', localStorage.getItem('token'));
        formData1.append('location', selectedUnit);
        axios.post(API.Records, formData1, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        })
            .then((res) => {
                this.setState({ allProgram: res.data.data })

                const formattedDate = moment(this.state.date).format('DD/MM/YYYY');
                const filteredItems = this.filterItemsByDate1(formattedDate);

                console.log(filteredItems)
                const filteredLocationItems = filteredItems.filter(item => item.location === selectedUnit);

                console.log(filteredLocationItems)

                const filteredSumStatusItems = filteredLocationItems.filter(item => {
                    console.log(item.date, formattedDate)
                    return item.sum_status === "0";
                })

                const transformedLocations1 = filteredSumStatusItems.map(item => ({
                    label: `${item.program_name} (${item.fromTime + '-' + item.toTime})`,
                    value: item.id
                }));

                this.setState({ today: transformedLocations1 });
            })
    };

    handleProgramChange = (selectedUnit) => {
        console.log(selectedUnit)


        const filteredLocationItems = this.state.allProgram.find(item => item.id === selectedUnit);
        console.log(filteredLocationItems)
        this.setState({
            oneProgram: filteredLocationItems
        })


    };
    render() {
        return (
            <div>
                <nav
                    className="navbar navbar-top navbar-expand navbar-dark border-bottom"
                    style={{
                        position: 'fixed',
                        left: 0,
                        right: 0,
                        top: 0,
                        zIndex: 1,
                    }}
                >
                    <div className="container pad_z">
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            <div className="col-1 pad_z">
                                <i
                                    className="fa fa-arrow-left back-btn grey-text"
                                    onClick={() => this.props.history.goBack()}
                                />
                            </div>
                            <div className="col-sm-6 text-center pad_z" style={{ fontSize: 20 }}>
                                Classroom Training Record
                            </div>
                        </div>
                    </div>
                </nav>

                <div style={{ height: 60 }}></div>
                <Container>
                    <Tabs defaultActiveKey="records" id="tabs-example" className="mt-5 mb-3">
                        <Tab eventKey="records" title="Plan">
                            {/* Search Bar */}
                            <InputGroup className="mb-3">
                                <FormControl
                                    placeholder="Search by Date/Training Name/Trainer"
                                    value={this.state.searchText}
                                    onChange={(e) => this.onChangeText(e.target.value)}
                                />
                                <Button variant="outline-secondary" onClick={this.clearText}>
                                    Clear
                                </Button>
                            </InputGroup>

                            {/* Records List */}
                            <div>
                                {this.state.localOfflineProgramsList.map((item, index) => (
                                    <div
                                        key={index}
                                        className="shadow mb-3 p-3"
                                        style={{
                                            backgroundColor: '#ebe0e5',
                                            borderRadius: '5px',
                                            minHeight: '80px',
                                            width: '98%',
                                            marginBottom: '10px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => this.toggleShowMore(index)}
                                    >
                                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0 10px' }}>
                                            <span style={{ fontSize: '12px', color: 'black' }}>{item.date}</span>
                                            <span className="chevron-icon" style={{ fontSize: '20px' }}>
                                                <i className={`fa ${item.showMore ? 'fa-chevron-up' : 'fa-chevron-down'}`} />
                                            </span>
                                        </div>

                                        <div style={{ padding: '5px 10px' }}>
                                            <h5 style={{ fontSize: '16px', color: 'black' }}>{item.program_name}</h5>
                                            <p style={{ fontSize: '14px', color: 'black' }}>Training by {item.trainer}</p>

                                            {item.showMore && (
                                                <div>
                                                    <p style={{ fontSize: '12px', color: 'black' }}>Venue: {item.place}</p>
                                                    <p style={{ fontSize: '12px', color: 'black' }}>
                                                        Time: {item.fromTime} - {item.toTime}
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Tab>

                        <Tab eventKey="attendance" title="Attendance">
                            <div style={{ marginTop: '10px', marginLeft: '15px', marginRight: '15px', alignItems: 'center' }}>
                                {this.state.seperate.map((item, index) => {
                                    return (
                                        <div
                                            key={index}
                                            onClick={() => this.toggleShowMoreAttendance(index)}
                                            style={{
                                                borderRadius: '5px',
                                                minHeight: '80px',
                                                width: '98%',
                                                paddingTop: '0',
                                                paddingLeft: '5px',
                                                paddingRight: '5px',
                                                backgroundColor:
                                                    item.sum_status === '0'
                                                        ? '#fff2cc'
                                                        : item.present === "0"
                                                            ? '#ffdfda'
                                                            : '#cce0cc',
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'flex-start',
                                                marginBottom: '10px',
                                                borderLeftWidth: '0',
                                                borderLeftColor: '#fff',
                                                cursor: 'pointer',
                                                position: 'relative',
                                            }}
                                        >
                                            <div style={{ flex: 1, marginTop: 5 }}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        marginBottom: '0',
                                                        marginTop: '0',
                                                        paddingLeft: '5px',
                                                        paddingRight: '10px',
                                                    }}
                                                >
                                                    <span style={{ fontSize: '11px', color: 'black', alignSelf: 'flex-end' }}>
                                                        {item.date}
                                                    </span>
                                                </div>
                                                <div
                                                    style={{
                                                        flex: 1,
                                                        marginTop: '5px',
                                                        marginBottom: '5px',
                                                        paddingLeft: '5px',
                                                        paddingRight: '10px',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            alignSelf: 'flex-start',
                                                            justifyContent: 'space-between',
                                                        }}
                                                    >
                                                        <p
                                                            style={{
                                                                fontSize: '16px',
                                                                paddingBottom: '5px',
                                                                color: 'black',
                                                                margin: 0,
                                                            }}
                                                        >
                                                            {item.program_name}
                                                        </p>
                                                    </div>
                                                    {item.showMore && (
                                                        <div style={{ marginTop: '5px' }}>
                                                            <div>
                                                                <p
                                                                    style={{
                                                                        fontSize: '14px',
                                                                        paddingBottom: '5px',
                                                                        color: 'black',
                                                                    }}
                                                                >
                                                                    Training by {item.trainer}
                                                                </p>
                                                                <div style={{ display: 'flex' }}>
                                                                    <p
                                                                        style={{
                                                                            fontSize: '12px',
                                                                            paddingBottom: '5px',
                                                                            color: 'black',
                                                                        }}
                                                                    >
                                                                        {item.timing}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <p
                                                                style={{
                                                                    fontSize: '12px',
                                                                    paddingBottom: '5px',
                                                                    color: 'black',
                                                                }}
                                                            >
                                                                Feedback Rating: {item.rating}
                                                            </p>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    justifyContent: 'space-between',
                                                                }}
                                                            >
                                                                <p
                                                                    style={{
                                                                        fontSize: '12px',
                                                                        paddingBottom: '0',
                                                                        color: 'black',
                                                                    }}
                                                                >
                                                                    Post Test Score: {item.result || 'N/A'}
                                                                </p>
                                                                <p
                                                                    style={{
                                                                        fontSize: '12px',
                                                                        paddingBottom: '0',
                                                                        color: 'black',
                                                                    }}
                                                                >
                                                                    Duration in hrs: {item.duration}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        marginBottom: '5px',
                                                        marginTop: '0',
                                                        paddingLeft: '5px',
                                                        paddingRight: '10px',
                                                    }}
                                                >
                                                    <span
                                                        style={{
                                                            fontSize: '11px',
                                                            color: item.present === '0' ? '#920067' : '#006400',
                                                            alignSelf: 'flex-end',
                                                        }}
                                                    >
                                                        {item.sum_status === '0'
                                                            ? 'Attendance Pending Validation'
                                                            : item.present === '0'
                                                                ? 'Attendance Rejected'
                                                                : 'Attendance Validated'}
                                                    </span>
                                                    <span
                                                        style={{
                                                            fontSize: '11px',
                                                            color: item.present === '0' ? '#920067' : '#006400',
                                                            alignSelf: 'flex-end',
                                                        }}
                                                    >
                                                        {moment(item.created_at, 'DD-MM-YYYY hh:mm:ss A').format('DD/MM/YYYY hh:mm A')}
                                                    </span>
                                                </div>
                                                <i
                                                    className={`fa ${item.showMore ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                                                    style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '20px' }}
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <Button
                                variant="primary"
                                onClick={this.handleAttendanceModalShow}
                                style={{
                                    position: 'fixed',
                                    bottom: '20px',
                                    right: '20px',
                                    borderRadius: '50%',
                                    width: '60px',
                                    height: '60px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '30px',
                                    zIndex: 1000,
                                }}
                            >
                                +
                            </Button>

                        </Tab>
                    </Tabs>
                </Container>

                <Modal
                    show={this.state.showAttendanceModal}
                    onHide={this.handleAttendanceModalClose}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Attendance</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            {/* Unit Name Select Box */}
                            <Form.Group controlId="unitName">
                                <Form.Label>Unit Name <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Select
                                    options={this.state.location}
                                    value={this.state.location.find(option => option.value === this.state.selectedUnit)}
                                    onChange={(selectedOption) => {
                                        this.setState({ selectedUnit: selectedOption.value }, () => {
                                            this.handleUnitChange(selectedOption.value);
                                        });
                                    }}
                                    placeholder="Select Unit"
                                />
                            </Form.Group>

                            {/* Date Picker */}
                            <Form.Group controlId="date">
                                <Form.Label>Date</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={moment(this.state.date).format('DD/MM/YYYY')}
                                    disabled
                                />
                            </Form.Group>

                            {/* Training Program Select Box */}
                            <Form.Group controlId="trainingProgram">
                                <Form.Label>Name of the Training Program <span style={{ color: 'red' }}>*</span></Form.Label>
                                <Select
                                    options={this.state.today}
                                    value={this.state.today.find(option => option.value === this.state.trainingProgram)}
                                    onChange={(selectedOption) => {
                                        this.setState({ trainingProgram: selectedOption.value }, () => {
                                            this.handleProgramChange(selectedOption.value);
                                        })
                                    }}
                                    placeholder="Select Training Program"
                                />
                            </Form.Group>

                            {this.state.oneProgram.length !== 0 && (
                                <>
                                    {/* Date Field */}
                                    <div className="mb-3" style={{ border: '1px solid #e9ecef', padding: '10px', borderRadius: '5px' }}>
                                        <Form.Label style={{ fontSize: '18px' }}>Date<span style={{ color: 'red' }}> *</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={this.state.oneProgram.date}
                                            readOnly
                                            style={{ backgroundColor: 'transparent', border: 'none', color: '#1D1F1F' }}
                                        />
                                    </div>

                                    {/* Time Field */}
                                    <div className="mb-3" style={{ border: '1px solid #e9ecef', padding: '10px', borderRadius: '5px' }}>
                                        <Form.Label style={{ fontSize: '18px' }}>Time<span style={{ color: 'red' }}> *</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={`${this.state.oneProgram.fromTime} - ${this.state.oneProgram.toTime}`}
                                            readOnly
                                            style={{ backgroundColor: 'transparent', border: 'none', color: '#1D1F1F' }}
                                        />
                                    </div>

                                    {/* Duration Field */}
                                    <div className="mb-3" style={{ border: '1px solid #e9ecef', padding: '10px', borderRadius: '5px' }}>
                                        <Form.Label style={{ fontSize: '18px' }}>Duration in hours<span style={{ color: 'red' }}> *</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={this.state.oneProgram.duration}
                                            readOnly
                                            style={{ backgroundColor: 'transparent', border: 'none', color: '#1D1F1F' }}
                                        />
                                    </div>

                                    {/* Trainer Field */}
                                    <div className="mb-3" style={{ border: '1px solid #e9ecef', padding: '10px', borderRadius: '5px' }}>
                                        <Form.Label style={{ fontSize: '18px' }}>Trainer<span style={{ color: 'red' }}> *</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={this.state.oneProgram.trainer}
                                            readOnly
                                            style={{ backgroundColor: 'transparent', border: 'none', color: '#1D1F1F' }}
                                        />
                                    </div>

                                    {/* Venue Field */}
                                    <div className="mb-3" style={{ border: '1px solid #e9ecef', padding: '10px', borderRadius: '5px' }}>
                                        <Form.Label style={{ fontSize: '18px' }}>Venue<span style={{ color: 'red' }}> *</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={this.state.oneProgram.place}
                                            readOnly
                                            style={{ backgroundColor: 'transparent', border: 'none', color: '#1D1F1F' }}
                                        />
                                    </div>

                                    <div className="mb-3" style={{ border: this.state.requiredCheck && this.state.rating === 0 ? '1px solid red' : '1px solid #e9ecef', padding: '10px', borderRadius: '5px' }}>
                                        <Form.Label style={{ fontSize: '18px' }}>Rate the Training Program<span style={{ color: 'red' }}> *</span></Form.Label>
                                        <ReactStars
                                            count={5}
                                            value={this.state.rating}
                                            size={25}
                                            activeColor="#FFD700"
                                            onChange={(newRating) => this.setState({ rating: newRating })}
                                        />
                                    </div>

                                    {/* Feedback Text Area */}
                                    <div className="mb-3" style={{ border: '1px solid #D3D3D3', padding: '10px', borderRadius: '5px' }}>
                                        <Form.Label style={{ fontSize: '18px' }}>Remarks (if any)...</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            placeholder="Remarks (if any)..."
                                            value={this.state.feedback}
                                            onChange={(e) => this.setState({ feedback: e.target.value })}
                                            style={{ resize: 'none', backgroundColor: 'transparent', border: 'none', color: '#1D1F1F' }}
                                        />
                                    </div>
                                </>
                            )}
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleAttendanceModalClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={this.handleSubmit}>
                            Submit
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal show={this.state.showAlert} onHide={this.closeAction}>
                    <Modal.Header closeButton>
                        <Modal.Title>Koach</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>{this.state.alertMessage}</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => window.location.reload()}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Saved Confirmation Modal */}
                <Modal show={this.state.showSaved} onHide={() => this.setState({ showSaved: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Attendance Submitted</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p>Your attendance has been submitted for validation (approval) by the trainer.</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={() => window.location.reload()}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default Classroom;
